/**
 * Feature Card Template
 *
 * A Framer-inspired feature highlight card with text and image in a card layout.
 */

const featureCard = {
  id: 'feature-card',
  name: 'Feature Card',
  category: 'content',
  description: 'Feature highlight with text and image in a card',
  thumbnail: null,
  content: {
    section_type: 'layout-1',
    sectionBackgroundColor: '#f5f5f5',
    backgroundImage: '',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    marginTop: '0',
    marginBottom: '0',
    paddingTop: '64',
    paddingBottom: '64',
    paddingLeft: '24',
    paddingRight: '24',
    components: [
      {
        id: 'feature-card-container',
        type: 'container',
        props: {
          width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
          height: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          maxWidth: { base: { value: 900, unit: 'px' }, tablet: null, desktop: null },
          padding: { base: { top: 48, bottom: 48, left: 48, right: 48, unit: 'px' }, tablet: null, desktop: null },
          margin: { base: { top: 0, bottom: 0, left: 'auto', right: 'auto', unit: 'px' }, tablet: null, desktop: null },
          backgroundColor: '#ffffff',
          backgroundImageUrl: '',
          borderWidth: 0,
          borderStyle: 'solid',
          borderColor: 'transparent',
          borderRadius: 16,
          overflow: 'visible',
          visibility: { base: true, tablet: null, desktop: null },
          position: 'relative',
          top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
          zIndex: 'auto',
          customCSS: 'box-shadow: 0 4px 12px rgba(0,0,0,0.08);',
        },
        children: [
          {
            id: 'feature-card-row',
            type: 'row',
            props: {
              direction: { base: 'horizontal', tablet: null, desktop: null },
              gap: 'lg',
              alignment: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              columnLayout: { base: 'custom', tablet: null, desktop: null },
              columnWidths: [],
              width: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              maxWidth: { base: { value: 'none', unit: 'px' }, tablet: null, desktop: null },
              padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
              backgroundColor: 'transparent',
              backgroundImageUrl: '',
              borderWidth: 0,
              borderStyle: 'solid',
              borderColor: 'transparent',
              borderRadius: 0,
              overflow: 'visible',
              visibility: { base: true, tablet: null, desktop: null },
              position: 'relative',
              top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
              zIndex: 'auto',
              customCSS: '',
            },
            children: [
              // Left Column - Text Content (60%)
              {
                id: 'feature-card-col-left',
                type: 'column',
                props: {
                  gap: 'md',
                  alignItems: 'flex-start',
                  justifyContent: 'center',
                  span: { base: 12, tablet: 7, desktop: 7 },
                  width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [
                  {
                    id: 'feature-card-heading',
                    type: 'text',
                    props: {
                      content: 'Infinite canvas.',
                      element: 'h2',
                      fontFamily: 'System Default',
                      fontSize: 32,
                      fontWeight: 'bold',
                      lineHeight: 1.2,
                      letterSpacing: 0,
                      color: '#1a1a1a',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                  {
                    id: 'feature-card-description',
                    type: 'text',
                    props: {
                      content: 'Design pages on our Canvas with world-class layout tools.',
                      element: 'p',
                      fontFamily: 'System Default',
                      fontSize: 16,
                      fontWeight: 'normal',
                      lineHeight: 1.6,
                      letterSpacing: 0,
                      color: '#666666',
                      textAlign: 'left',
                      textTransform: 'none',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
              // Right Column - Image (40%)
              {
                id: 'feature-card-col-right',
                type: 'column',
                props: {
                  gap: 'md',
                  alignItems: 'center',
                  justifyContent: 'center',
                  span: { base: 12, tablet: 5, desktop: 5 },
                  width: { base: { value: '100%', unit: '%' }, tablet: null, desktop: null },
                  padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                  backgroundColor: 'transparent',
                  borderWidth: 0,
                  borderStyle: 'solid',
                  borderColor: 'transparent',
                  borderRadius: 0,
                  overflow: 'visible',
                  visibility: { base: true, tablet: null, desktop: null },
                  position: 'relative',
                  top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                  zIndex: 'auto',
                  customCSS: '',
                },
                children: [
                  {
                    id: 'feature-card-image',
                    type: 'image',
                    props: {
                      src: 'https://via.placeholder.com/300x200/f5f5f5/cccccc?text=Feature',
                      alt: 'Feature image placeholder',
                      linkUrl: '',
                      openInNewTab: false,
                      width: { base: { value: 100, unit: '%' }, tablet: null, desktop: null },
                      height: { base: { value: 200, unit: 'px' }, tablet: null, desktop: null },
                      maxWidth: { base: { value: 300, unit: 'px' }, tablet: null, desktop: null },
                      objectFit: 'cover',
                      objectPosition: 'center',
                      aspectRatio: 'auto',
                      padding: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      margin: { base: { top: 0, bottom: 0, left: 0, right: 0, unit: 'px' }, tablet: null, desktop: null },
                      borderWidth: 0,
                      borderStyle: 'solid',
                      borderColor: 'transparent',
                      borderRadius: 8,
                      opacity: 100,
                      filter: 'none',
                      visibility: { base: true, tablet: null, desktop: null },
                      position: 'static',
                      top: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      right: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      bottom: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      left: { base: { value: 'auto', unit: 'px' }, tablet: null, desktop: null },
                      zIndex: 'auto',
                      customCSS: '',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
};

export default featureCard;
